const InfinityIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.00012207"
        width="48"
        height="48"
        rx="4"
        fill="#17C289"
        fill-opacity="0.11"
      ></rect>
      <path
        d="M30.1173 18.6602C32.9298 18.6602 35.2501 20.9453 35.2501 23.7578V24.7773C35.2501 27.5898 32.9298 29.875 30.1173 29.9102C28.7814 29.9102 27.4806 29.3477 26.5314 28.3984L24.0001 25.8672L21.4337 28.3984C20.4845 29.3477 19.1837 29.875 17.8478 29.875C15.0353 29.875 12.7501 27.5898 12.7501 24.7773V23.7578C12.7501 20.9453 15.0353 18.6602 17.8478 18.625C19.1837 18.625 20.4845 19.1875 21.4337 20.1367L24.0001 22.668L26.5314 20.1367C27.4806 19.1875 28.7814 18.6602 30.1173 18.6602ZM19.8517 26.8164L22.3829 24.2852L19.8517 21.7188C19.3243 21.1914 18.5861 20.9102 17.8478 20.9102C16.2657 20.9102 15.0001 22.1758 15.0001 23.7578V24.7773C15.0001 26.3594 16.2657 27.625 17.8478 27.6602C18.5861 27.6602 19.3243 27.3438 19.8517 26.8164ZM33.0001 24.7773V23.7578C33.0001 22.1758 31.6993 20.875 30.1173 20.9102C29.379 20.9102 28.6407 21.1914 28.1134 21.7188L25.5822 24.2852L28.1134 26.8164C28.6407 27.3438 29.379 27.6602 30.1173 27.6602C31.6993 27.6602 33.0001 26.3594 33.0001 24.7773Z"
        fill="#17C289"
      ></path>
    </svg>
  );
};
export default InfinityIcon;
